var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { actions as formActions } from 'react-redux-form';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

import { Icon } from "../../UI";
import {
  searchDocuments as searchDocumentsAction,
  processFilters } from "../actions/libraryActions";

import { t, Translate } from "../../I18N";
import { wrapDispatch } from "../../Multireducer";
import ModalTips from "../../App/ModalTips";
import { SearchTipsContent } from "../../App/SearchTipsContent";
import { submitNewSearch } from "../../SemanticSearch/actions/actions";
import { FeatureToggleSemanticSearch } from "../../SemanticSearch/components/FeatureToggleSemanticSearch";

import { Form } from "../../Forms/Form";


const mapStateToProps = (state) => {
  const { search, filters } = state.library;
  return {
    initSearch: search,
    initFilters: filters
  };
};

const mapDispatchToProps = (dispatch) =>
bindActionCreators(
  {
    searchDocuments: searchDocumentsAction,
    change: formActions.change,
    semanticSearch: submitNewSearch
  },
  wrapDispatch(dispatch, 'library')
);

const connector = connect(mapStateToProps, mapDispatchToProps);



const SearchBarComponent = ({
  initSearch,
  initFilters,

  searchDocuments,
  change,
  semanticSearch
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const search = processFilters(initSearch, initFilters.toJS());
  const [searchTerm, setSearchTerm] = useState(search.searchTerm);
  const resetSearch = () => {
    change('library.search.searchTerm', '');
    const newSearch = _objectSpread({}, search);
    newSearch.searchTerm = '';
    searchDocuments({ search: newSearch, location, navigate });
    setSearchTerm('');
  };

  let debouncedSearch;
  useEffect(() => {
    if (debouncedSearch) clearTimeout(debouncedSearch);
    debouncedSearch = setTimeout(() => {
      change('library.search.searchTerm', searchTerm);
    }, 350);
    return () => clearTimeout(debouncedSearch);
  }, [searchTerm, change]);

  const submitSemanticSearch = () => {
    semanticSearch(search);
  };

  const doSearch = (newSearch) => {
    change('library.search.searchTerm', searchTerm);
    searchDocuments({ search: _objectSpread(_objectSpread({}, newSearch), {}, { searchTerm }), location, navigate });
  };

  return (/*#__PURE__*/
    _jsx("div", { className: "search-box" }, void 0, /*#__PURE__*/
    _jsx(Form, { model: "library.search", onSubmit: doSearch }, void 0, /*#__PURE__*/
    _jsx("div", { className: `input-group${search.searchTerm ? ' is-active' : ''}` }, void 0, /*#__PURE__*/
    _jsx("input", {
      type: "text",
      placeholder: t('System', 'Search', null, false),
      "aria-label": t('System', 'Search text description', null, false),
      className: "form-control",
      autoComplete: "off",
      value: searchTerm,
      onChange: (e) => setSearchTerm(e.target.value) }
    ), /*#__PURE__*/
    _jsx(Icon, { icon: "times", onClick: resetSearch, "aria-label": "Reset Search input" }), /*#__PURE__*/

    _jsx("button", { type: "submit", className: "search-icon-wrapper" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "search", "aria-label": "Search button" })
    )
    ), /*#__PURE__*/
    _jsx(FeatureToggleSemanticSearch, {}, void 0, /*#__PURE__*/
    _jsx("button", {
      disabled: !search.searchTerm,
      type: "button",
      onClick: submitSemanticSearch,
      className: "btn btn-success semantic-search-button" }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "flask" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Semantic Search")
    )
    )
    ), /*#__PURE__*/
    _jsx(ModalTips, {
      label: t('System', 'Search Tips', null, false),
      title: t('System', 'Narrow down your searches', null, false) }, void 0, /*#__PURE__*/

    _jsx(SearchTipsContent, {})
    )
    ));

};

const container = connector(SearchBarComponent);
export { container as SearchBar };